module.exports = __webpack_public_path__ + "media/LandingPageAssets/LouiseImage2-3f842ee2.png";